var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CheckboxGroup',{on:{"on-change":_vm.getSelect},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm._l((_vm.dicList),function(ele,index){return _c('Checkbox',{key:ele.code,attrs:{"label":ele.code}},[_vm._v(_vm._s(ele.name))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be3b0dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/components/data-checkbox.vue
// module id = 81
// module chunks = 0